
define('text!modules/campaign/bulkedit/targeting/location/templates/bin_group_header.html',[],function () { return '<div class="group-c">{{bin_group_name}}&nbsp;({{count}})</div>\n';});

